<template>
  <MerchantWechatProfile v-if="isApplymentProfileDetail" />
  <div v-else>
    <div class="base_content region-store-context">
      <RegionStoreSelector v-model="selectedRegionStoreId" @change="handleRegionStoreChange" />
    </div>
    <StoreWechatProfile v-if="selectedRegionStoreId" :key="selectedRegionStoreId" />
    <el-alert v-else class="mt10" type="warning" :closable="false" title="请先选择要查看的管辖门店。" />
  </div>
</template>

<script>
import RegionStoreSelector from "@/views/apps/weishop/region/components/RegionStoreSelector.vue";
import regionPageAdapter from "@/views/apps/weishop/region/mixins/regionPageAdapter";
import StoreWechatProfile from "@/views/apps/weishop/store/wechat/profile.vue";
import MerchantWechatProfile from "@/views/apps/weishop/merchants/setting/wechat/merchant_profile.vue";

export default {
  name: "RegionStoreWechatProfileAdapter",
  mixins: [regionPageAdapter],
  components: {
    RegionStoreSelector,
    StoreWechatProfile,
    MerchantWechatProfile,
  },
  data() {
    return {
      selectedRegionStoreId: sessionStorage.getItem("currentRegionStoreId") || "",
    };
  },
  computed: {
    isApplymentProfileDetail() {
      return !!(this.$route && this.$route.query && this.$route.query.id);
    },
  },
  created() {
    if (this.isApplymentProfileDetail) return;
    this.loadRegionContext().then(() => {
      this.selectedRegionStoreId = this.currentRegionStoreId;
    }).catch((error) => {
      this.showRegionApiError(error, "获取区域门店失败");
    });
  },
  methods: {
    handleRegionStoreChange(storeId) {
      this.selectedRegionStoreId = this.setCurrentRegionStoreId(storeId);
    },
  },
};
</script>

<style lang="scss" scoped>
.region-store-context {
  margin-bottom: 10px;
}
</style>
